import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormField, TabsTimelineSub, Upload } from 'components';
import { isAuditor, isAuditorFinal, isCommittee, isCommitteeFinal, isInvestor, isObjection, isObjectionCommittee, isObjectionCommitteeFinal, isDocumentsUpload, isOperator, isCommitteeAfterOperations, isCommitteeAfterOperationsFinal, isObjectionDocuments, isObjectionDocumentsCommittee, isObjectionDocumentsCommitteeFinal, isBeneficiary } from 'utils';
import { DownloadedItems } from './components/index';
import { flattenDocs } from './utils';
import DocsInvestor from './components/docsInvestor';
import { isEmpty, isNil } from 'lodash';
import { Col, Empty, Form, Row } from 'antd';
import { content} from './components/docsInvestor/content';
import { contentAdditional } from './components/docsInvestor/contentAdditional';
import { useForm } from 'antd/lib/form/Form';

const DocumentsBeneficiary = () => {
  const dispatch = useDispatch();
  const form = useForm();
  const user = useSelector(state => state.user);
  const docs = useSelector(state => state.forms.documents);
  const task = useSelector(state => state.forms.task);
  const submissionDate = useSelector(state => state.forms.submissionDate);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  //check submissionDate in case of return to Beneficiary from auditor
  //so means that Beneficiary need to add only Additional Documents in Documents tab
  const viewMode = isViewMode || !isBeneficiary(user.groups) || !isNil(submissionDate);
  const flatDocs = flattenDocs(docs);
  const documents = useSelector(state => state.forms.documents);
  const ownerStatus = useSelector(state => state.forms.carrier.ownerStatus);
  const residence = useSelector(state => state.forms.carrier.residence);  
  const ameaMember = useSelector(state => state.forms.carrier.ameaMember);
  const legalChildren = useSelector(state => state.forms.carrier.legalChildren);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const returnAuditorMessage = useSelector(state => state.forms.audit.returnAuditorMessage);

  return !viewMode ? (
      <div>
        <div className="mt-6"/>
        <DocsInvestor group={'documents'} />
        <div className="mt-2 " />
      </div>
    ) 
    :
    (
      <>
        {/* <div style={{minHeight:"500px"}}  > */}
        <div   >
          <div className="mt-6"/>
          {
            isEmpty(documents) ?
            <div style={{position:"absolute", top:"10%", left:"50%"}}>
              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
            </div>
            :
            <>
              <DownloadedItems content={content(ownerStatus, ameaMember, residence, legalChildren)} docs={flatDocs} />

              {activeTaskName !== 'task.name.application_returned_to_beneficiary' &&
                <div className='mt-3'>
                <DownloadedItems content={contentAdditional(ownerStatus, residence)} docs={flatDocs} />
              </div>}
            </>
          }
        </div>
        {isBeneficiary(user.groups) && activeTaskName === 'task.name.application_returned_to_beneficiary' && !isViewMode &&
          <div className='mt-5'>
            <Col className="gutter-row" span={12}>
                <FormField
                  label={'Σχόλιο Αξιολογητή'}
                  type='textarea'
                  disabled={true}
                  rows={6}
                  bold={true}
                  value={returnAuditorMessage}
                />
            </Col>
            <div className='mt-3'>
              {contentAdditional(ownerStatus, residence).map((item, index) => {
                return (
                  <Upload item={item} subFileCode={item.fileCode} key={index} group={'documents'} />
                );
              })}
            </div>
          </div>
        }
        
        </>
  );
};

DocumentsBeneficiary.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocumentsBeneficiary;
